'use client'

import type { SerializedAllFeaturesEditorState } from '@/admin/lexical/features'
import type { ImageData, VideoData } from '@/frontend-types'
import Image from 'next/image'
import { type FC } from 'react'
import { PlaceholderImage } from '../atoms/PlaceholderImage'
import { VideoBlock } from '../blocks/VideoBlock'
import { RenderLexicalContent } from '../RenderContentBlocks'

export type NewsSummaryBlockProps = {
	image?: ImageData
	video?: VideoData
	blocks: SerializedAllFeaturesEditorState | null | undefined
}

export const NewsSummaryBlock: FC<NewsSummaryBlockProps> = ({ video, image, blocks }) => {
	const imageSizes = '(max-width: 1023px) 100vw, (max-width: 1559px) 83.33vw, 1136px'

	return (
		<div>
			<div className="relative aspect-video h-auto w-full overflow-hidden rounded-sm my-xl">
				{video ? (
					<VideoBlock thumbnail={image} thumbnailSizes={imageSizes} video={video} />
				) : image ? (
					<Image src={image.src} alt={image.alt} fill className="object-cover" sizes={imageSizes} />
				) : (
					<PlaceholderImage />
				)}
			</div>
			<div className="rounded-sm bg-blue-tint-10 px-2xl py-4xl text-blue-shade-40">
				<div className="grid grid-cols-4 tablet-l:grid-cols-10 gap-x-gutter">
					<div className="col-span-full tablet-l:col-start-2 tablet-l:col-span-8">
						<span className="mb-sm block text-h5">In short</span>
						<RenderLexicalContent data={blocks} layout="nested" />
					</div>
				</div>
			</div>
		</div>
	)
}

export default NewsSummaryBlock
